import {DateTime} from 'luxon';

export const CHART_COLORS = [
  '#8864ee', '#FF8356', '#22c55e', '#3b82f6', '#f59e0b',
  '#ec4899', '#14b8a6', '#a855f7', '#ef4444', '#64748b',
];

export const formatCurrency = (n: number): string =>
  `₪${Math.round(n || 0).toLocaleString('en-US')}`;

export const formatTrendLabel = (date: string, granularity: 'daily' | 'monthly'): string => {
  if (granularity === 'monthly') {
    const dt = DateTime.fromFormat(date, 'yyyy-MM');
    return dt.isValid ? dt.toFormat('MM/yyyy') : date;
  }
  const dt = DateTime.fromFormat(date, 'yyyy-MM-dd');
  return dt.isValid ? dt.toFormat('dd/MM') : date;
};

export const doughnutOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const,
      rtl: true,
      labels: {boxWidth: 12, font: {size: 11}, padding: 12},
    },
  },
};

export const barOptions = (currency = false) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {legend: {display: false}},
  scales: {
    x: {grid: {display: false}, ticks: {font: {size: 10}}},
    y: {
      beginAtZero: true,
      grid: {color: '#f1f1f1'},
      ticks: {
        font: {size: 10},
        callback: (val: number | string) => (currency ? formatCurrency(Number(val)) : val),
      },
    },
  },
});

export const lineOptions = (currency = false) => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {legend: {display: false}, tooltip: {rtl: true}},
  scales: {
    x: {grid: {display: false}, ticks: {font: {size: 10}, maxTicksLimit: 8, maxRotation: 0}},
    y: {
      beginAtZero: true,
      grid: {color: '#f1f1f1'},
      ticks: {
        font: {size: 10},
        callback: (val: number | string) => (currency ? formatCurrency(Number(val)) : val),
      },
    },
  },
});
